// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"5afec70e","571":"cec46866","787":"046056e3"}[chunkId] + ".chunk.js";
};